import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const FormPriceHotel = (props) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      price: props.tarif.item.price,
      rooms_available: props.tarif.item.rooms_available,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    props.tarif.item.price = parseFloat(data.price);
    props.tarif.item.rooms_available = parseInt(data.rooms_available);
    await props.changePrice(props.tarif, props.index, data);
    setLoading(false);
  };

  const rule = {
    type: "number",
    placeholder: props.t("price"),
    messageError: props.t("price_is__required"),
    className: "input-blue text-dark w-100 p-3 border fw-light ",
    size: "md",
    rules: {
      required: props.t("mandatory"),
    },
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          {["price", "rooms_available"].map((field) => (
            <Col md="12" key={field} style={{ marginBottom: "12px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "500",
                  marginBottom: 5,
                }}
              >
                {props.t(field).toUpperCase()}
              </label>
              <IController
                elment={field}
                item={rule}
                control={control}
                errors={errors}
                register={register}
              />
            </Col>
          ))}
          <Col md="12" className="mt-3">
            <Form
              as="button"
              type="submit"
              className="btn-blue p-3 rounded-3 fw-bold w-100"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></Form>
              ) : (
                props.t("edit")
              )}
            </Form>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormPriceHotel;
